const axios = require('axios').default

/**
 * ApiSiroleg : class merepresentasikan api-backend siroleg
 * @param {*} url : url backend
 * @param {*} timeout : timeout per request (jgn ngandelin kecepatan server, gunakan akal sehat)
 */
class ApiSiroleg {
    // private instance. made when initialized I guess
    constructor(url, timeout) {
        this.instance = axios.create({
            baseURL: url,
            timeout: timeout
        })

		this.token = null
    }

    //===================GENERIC SECTION========================================
    // setToken (token) : ngeset semua access token tiap request
    setToken (token) {
        this.instance.defaults.headers.common['Authorization'] = `Bearer ${token}`
		this.token = token
    }

    // generateUrl (endpoint) : menggenerate absolute url utk endpoint tertentu
    //  eg: generateUrl('cd/2') => https://apishinta.test/cd/2
    generateUrl (endpoint, param) {
        var url = this.instance.defaults.baseURL + endpoint.replace(/^\/+|\/+$/g, '')
		// add query string
		if (param) {
			url += '?'
			for (var k in param) {
				if (param[k]) {
					url += `&${k}=${param[k]}`
				}
			}
		}
		return url
    }

    // call GET on /endpoint
    getEndpoint (endpoint, params) {
        return this.instance.get(endpoint, {
			params: params
		})
    }

	// call GET with blob data type
	getEndpointBlob (endpoint) {
		return this.instance.get(endpoint, {
			responseType: 'blob'
		})
	}

    // call POST on /endpoint
    postEndpoint (endpoint, data, params) {
        return this.instance.post(endpoint, data, {
            params: params
        })
    }

    // call PUT on /endpoint
    putEndpoint (endpoint, data, params) {
        return this.instance.put(endpoint, data, {
            params: params
        })
    }

    // call DELETE on /endpoint
    deleteEndpoint (endpoint, params) {
        return this.instance.delete(endpoint, {
            params: params
        })
    }

    //===================RESOURCE : PDF======================================================
    getPdf (doctype, id, param) {
        return this.instance.get('/pdf', {
            headers: {
                'Content-Type' : 'text/html'
            },
            params: {
                doc: doctype,
                id: id,
                ...param
            }
        })
    }

    // this one generate accessible url (supposedly) to download pdf
    generatePdfUrl (doctype, id, param) {
        var url = this.instance.defaults.baseURL + 'pdf' + `?doc=${doctype}&id=${id}`
        // dynamically add more to param
        if (param) {
            for (var k in param) {
                url += `&${k}=${param[k]}`
            }
        }

        return url
    }

    // this one attach resource to a specific endpoints
    attachFile (doctype, id, data, progressFn) {
        var url = `/${doctype}/${id}/lampiran`

        return this.instance.post(url, data.blob, {
            onUploadProgress: progressFn,
            headers: {
                ...this.instance.defaults.headers,

                'Content-Type'      : data.type,
                // 'Content-Length'    : data.blobsize,
                'X-Content-Filesize': data.filesize,
                'X-Content-Filename': data.filename
            }
        })
    }

    // this one attach resource to a specific uri
    attachFileToUri (uri, data, progressFn) {
        return this.instance.post(uri, data.blob, {
            onUploadProgress: progressFn,
            headers: {
                ...this.instance.defaults.headers,

                'Content-Type'      : data.type,
                'X-Content-Filesize': data.filesize,
                'X-Content-Filename': data.filename
            }
        })
    }

    // this one attach ONE raw file to a specific uri
    attachRawFileToUri (uri, file, progressFn) {
        var fd = new FormData();
        fd.append('file', file)
        return this.instance.post(uri, fd, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: progressFn
        })
    }

    // this one delete attachment by id
    // deleteAttachment (id) : DELETE /lampiran/id
    deleteAttachment (id) {
        return this.instance.delete('/lampiran/' + id)
    }

    // this downloads uri
    downloadUri (uri, headers, params, timeout) {
        return this.instance.get(uri, {
            responseType: 'arraybuffer',
            headers: {
                ...this.instance.defaults.headers,
                ...headers
            },
			params: params,
            timeout : timeout || this.instance.timeout
        })
    }

	// ==========================DATA REFERENSI====================================
	getPropinsi(queryData) {
		return this.instance.get('/propinsi', {
			params: queryData
		})
	}

	getPropinsiById(id, queryData) {
		return this.instance.get(`/propinsi/${id}`, {
			params: queryData
		})
	}

	getKotaKabByPropinsiId(propId, queryData) {
		return this.instance.get(`/propinsi/${propId}/kota_kab`, {
			params: queryData
		})
	}

	getKecamatanByKotaKabId(kotaKabId, queryData) {
		return this.instance.get(`/kota_kab/${kotaKabId}/kecamatan`, {
			params: queryData
		})
	}

	getKelurahanByKecamatanId(kecamatanId, queryData) {
		return this.instance.get(`/kecamatan/${kecamatanId}/kelurahan`, {
			params: queryData
		})
	}

	// ==========================SERVICE====================================
	service_ResolveWilayah(queryData) {
		return this.instance.get(`/service/ResolveWilayah`, {
			params: queryData
		})
	}

	service_StatistikTemuan(params) {
		return this.instance.get(`/service/StatistikTemuan`, {
			params: params
		})
	}

	// ======RESOURCE: Toko=================================================
	// GET /toko
	getToko(params) {
		return this.instance.get('/toko', {
			params: params
		})
	}

	// GET /toko/{id}
	getTokoById(id, params) {
		return this.instance.get(`/toko/${id}`, {
			params: params
		})
	}

	// POST /toko
	createToko(data, params) {
		return this.instance.post('/toko', data, {
			params: params
		})
	}

	// PUT /toko
	updateToko(id, data, params) {
		return this.instance.put(`/toko/${id}`, data, {
			params: params
		})
	}

	// DELETE /toko
	deleteToko(id, params) {
		return this.instance.delete(`/toko/${id}`, {
			params: params
		})
	}

	// ======RESOURCE: Temuan=================================================
	// GET /temuan
	getTemuan(params) {
		return this.instance.get('/temuan', {
			params: params
		})
	}

	// GET /temuan/{id}
	getTemuanById(id, params) {
		return this.instance.get(`/temuan/${id}`, {
			params: params
		})
	}

	// POST /temuan
	createTemuan(data, params) {
		return this.instance.post('/temuan', data, {
			params: params
		})
	}

	// PUT /temuan/{id}
	updateTemuan(id, data, params) {
		return this.instance.put(`/temuan/${id}`, data, {
			params: params
		})
	}

	// DELETE /temuan/{id}
	deleteTemuan(id, params) {
		return this.instance.delete(`/temuan/${id}`, {
			params: params
		})
	}

	// PUT /temuan/{id}/arsip
	arsipTemuan(id, data, params) {
		return this.instance.put(`/temuan/${id}/arsip`, data, {
			params: params
		})
	}

	// PUT /temuan/{id}/tindak_lanjut
	tindakLanjutiTemuan(id, data, params) {
		return this.instance.put(`/temuan/${id}/tindak_lanjut`, data, {
			params: params
		})
	}


	// ======RESOURCE: LOG=================================================
	// GET /log
	getLog(params) {
		return this.instance.get(`/log`, {
			params: params
		})
	}
}

export {
    ApiSiroleg
}



// WEBPACK FOOTER //
// ./src/libs/api-siroleg.js